import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import VueClipboard from 'vue-clipboard2';
import "./assets/sass/main.scss";
import "@/icons";

// vuex
import store from "./store";
import VueScreenSize from 'vue-screen-size';
import IdleVue from "idle-vue";

const eventsHub = new Vue();

Vue.use(IdleVue, {
    eventEmitter: eventsHub,
    store,
    idleTime: 5000, // 3 seconds
    startAtIdle: false
});

Vue.config.productionTip = false;
VueClipboard.config.autoSetContainer = true;

Vue.use(VueClipboard);
Vue.use(VueScreenSize);

new Vue({
    vuetify,
    router,
    store,
    render: h => h(App)
}).$mount('#app')



